module.exports = __webpack_public_path__ + "media/images/emblems/Altnau_CoA-556d0d017781a5fa70a08f7afc962acc.svg";